import apiInstance, { apiCall } from '@/helpers/apiInstance';
import { business } from '@icabbi/api-gateway-client';

const defaultState = {
  paxCoreBusinessPassengerClient: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  paxCoreBusinessPassengerClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (!state.paxCoreBusinessPassengerClient) {
      state.paxCoreBusinessPassengerClient = apiInstance({ dispatch, getters: rootGetters, Connector: business.PaxCoreConnector });
    }
    return state.paxCoreBusinessPassengerClient;
  },
  getBusinessPassengerList: (state) => state.businessPassengers,
};

const actions = {
  getBusinessPassengerList: apiCall((context, payload) => context.getters.paxCoreBusinessPassengerClient(context).getPassengerList({ payload })),
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
};
